// The words the app uses about a badge at a door, shared by the door screen and the
// maintenance panel so the two cannot drift apart.

/**
 * Kept short enough to stay on one line at 360px: a label that wraps makes the door's
 * card taller and moves the buttons under a thumb already on its way down.
 */
export const DOOR_VERDICT_LABELS: Record<EntryVerdict, string> = {
  registered: 'Has access',
  waitlisted: 'On waitlist',
  not_registered: 'Not registered',
  unknown_ticket: 'Not recognized',
  unverified: 'Cannot verify',
}

/**
 * The tail of a scanned code, which is what tells two scans apart: every badge at the
 * event starts with the same prefix. As much of a person as this app ever holds.
 */
export const badgeRef = (code: string): string => code.slice(-6).toUpperCase()
